import { useEffect, useRef } from 'react'

const EDGE_THRESHOLD_PX = 24
const SWIPE_MIN_DISTANCE_PX = 56

/**
 * 왼쪽 가장자리에서 오른쪽으로 스와이프 시 onBack 호출.
 * WebView/모바일에서 뒤로가기 버튼 대신 제스처로 뒤로가기 지원.
 */
export function useSwipeBack(onBack: (() => void) | undefined) {
  const state = useRef({
    startX: 0,
    tracking: false,
    triggerBack: false,
  })

  useEffect(() => {
    if (!onBack || typeof onBack !== 'function') return

    const { current } = state

    const handleTouchStart = (e: TouchEvent) => {
      const touch = e.touches[0]
      if (!touch || touch.clientX > EDGE_THRESHOLD_PX) return
      current.startX = touch.clientX
      current.tracking = true
      current.triggerBack = false
    }

    const handleTouchMove = (e: TouchEvent) => {
      if (!current.tracking) return
      const touch = e.touches[0]
      if (!touch) return
      const deltaX = touch.clientX - current.startX
      if (deltaX >= SWIPE_MIN_DISTANCE_PX) current.triggerBack = true
    }

    const handleTouchEnd = () => {
      if (current.triggerBack) {
        onBack()
      }
      current.tracking = false
      current.triggerBack = false
    }

    const handleTouchCancel = () => {
      current.tracking = false
      current.triggerBack = false
    }

    document.addEventListener('touchstart', handleTouchStart, { passive: true })
    document.addEventListener('touchmove', handleTouchMove, { passive: true })
    document.addEventListener('touchend', handleTouchEnd, { passive: true })
    document.addEventListener('touchcancel', handleTouchCancel, { passive: true })

    return () => {
      document.removeEventListener('touchstart', handleTouchStart)
      document.removeEventListener('touchmove', handleTouchMove)
      document.removeEventListener('touchend', handleTouchEnd)
      document.removeEventListener('touchcancel', handleTouchCancel)
    }
  }, [onBack])
}
